export const conf = {
    node_env: "production",
    mode: "summer"
};